import { observer } from 'mobx-react';
import * as React from 'react';

import ProductSearchStore from 'search/stores/product-search-store';
import { CustomRefinementListComponent } from './custom-parent-refinement-component';

interface FaucetsFilterProps {
  store: ProductSearchStore;
}

const FaucetsFilter = observer(
  class FaucetsFilter extends React.Component<FaucetsFilterProps> {
    private containerRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
      const { store } = this.props;
      const { faucetsFilterOpened: opened } = store;
      if (!opened && this.containerRef.current) {
        this.containerRef.current.style.display = 'none';
      }
    }

    render() {
      const { store } = this.props;
      const { faucetsFilterOpened: opened } = store;
      const classes = ['c-filters__group', opened ? 'is-open' : ''];
      return (
        <>
          <div className={classes.join(' ')}>
            <div
              className="c-filters__header c-accordion-toggle"
              onClick={() => {
                store.setFaucetsFilterOpened(!opened);
                if (this.containerRef.current) {
                  jQuery(this.containerRef.current).stop(true).slideToggle();
                }
              }}
            >
              <p className="c-filters__title">Faucets</p>
            </div>
            <div className="c-filters__container c-accordion-container" ref={this.containerRef}>
              <CustomRefinementListComponent
                attribute="faucets"
                limit={25}
                subrefinements={[
                  { attribute: 'lavatory_faucets', key: 'Lavatory Faucets' },
                  { attribute: 'kitchen_faucets', key: 'Kitchen Faucets' },
                ]}
              />
            </div>
          </div>
        </>
      );
    }
  }
);
export default FaucetsFilter;
